import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { SelectableInput } from "../selectable-input.model";
import { SwitchGroupSamplingComponent } from "./switch-group-sampling.component";

export interface ISwitchGroupSamplingOptions extends IDynamicInputOptions {
  name?: string;
  subLabel?: string;
  preceedingOffLabel?: string;
  followingOnLabel?: string;
  tooltip?: string;
  isRequired?: boolean;
  isMovable?: boolean;
  isSortable?: boolean;
  items?: SelectableInput[];
}

export class SwitchGroupSampling extends DynamicInput implements ISwitchGroupSamplingOptions {
  name: string;
  subLabel: string;
  preceedingOffLabel: string;
  followingOnLabel: string;
  tooltip: string;
  isMovable?: boolean;
  isSortable?: boolean;
  isRequired?: boolean;
  items: SelectableInput[] = [];

  readonly controlType = "switch-group-sampling";
  readonly componentType = SwitchGroupSamplingComponent;

  constructor(options: ISwitchGroupSamplingOptions = {}) {
    super(options);
    this.name = options.name;
    this.subLabel = options.subLabel;
    this.preceedingOffLabel = options.preceedingOffLabel;
    this.followingOnLabel = options.followingOnLabel;
    this.tooltip = options.tooltip;
    this.isRequired = options.isRequired || false;
    this.isMovable = options.isMovable || false;
    this.isSortable = options.isSortable || false;
    this.items = options.items || [];
  }
}
